import React, { useEffect, useContext, useState } from 'react'
import { IoIosArrowRoundForward } from "react-icons/io";
import { Link } from 'react-router-dom';
import { useHistory } from "react-router-dom"
import { AuthContext } from '../../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import Heading from '../../Fashion/Heading';
import viewbtn from '../../../assets/img/custom/blogview.png'
import './style.css'
import arrow from '../../../assets/img/custom/arrow.png'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import moment from 'moment';

const GiftBanner = (props) => {
    const { t, i18n } = useTranslation();
    const history = useHistory()
    const { getAuthUser, isAuthenticated, getCurrentBranch } = useContext(AuthContext)
    const authUser = getAuthUser()
    const isAuthentic = isAuthenticated()
    let settings = {
        arrows: true,
        dots: false,
        margin: 30,
        infinite: false,
        speed: 500,
        slidesToShow: props.title === 'Deals of The Month' ? 2 : 4,
        slidesToScroll: 1,
        responsive: [{

            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            }
        },
        ]
    };
    return (
        <>

            <section id="giftBannerBg" className="ptb-100 mb-3 mt-5">
                <div className="container mb-4">
                    <Heading heading={t('latestblogs')} para={t('latestblogssubheading')} />
                   
                        <Slider {...settings}>
                            {props?.homeblogs?.map((data, index) => (
                                <div className='px-2' key={index}>
                                    <div className="product_wrappers_one">
                                        <div className="thumb">

                                            <Link to={{
                                                    pathname: `/blog-details/${(data.name.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`
                                                                                       , state: {
                                                                                           service: data
                                                                                       }
                                                                                   }}
                                                className={"image"}>
                                                <img src={process.env.REACT_APP_IMG_URL + data.image} />
                                                <img className="hover-image" src={process.env.REACT_APP_IMG_URL + data.image}
                                                />
                                            </Link>

                                        </div>

                                        <div className="content blogcontent">
                                            <div className='mb-2'>
                                                <small className='text-warn float-left'>{data?.categoryId?.title[i18n.language]}</small> <small className='float-right font-weight-light' style={{ fontSize: 10 }}>{moment(data.createdDate).format("DD MMM yy")}</small>
                                            </div>

                                            <h5 className="title">
                                                <Link to={{
                                                    pathname: `/treatments/${(data?.title?.en)?.replaceAll(' ', '-')?.toLowerCase()}/${i18n.language}`, state: {
                                                        service: props.data
                                                    }
                                                }} >{data.name[i18n.language]}</Link>
                                            </h5>
                                            <small className='mb-2'>{data.about[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60) + '...'}</small>



                                            <Link to={{
                                                    pathname: `/blog-details/${(data.name.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`
                                                                                       , state: {
                                                                                           service: data
                                                                                       }
                                                                                   }} className='text-warn font-weight-light small'><span className='float-left mr-2'>{t('continuereading')}</span> <img src={arrow} className="mt-1" style={{ height: 10 }} /></Link>


                                        </div>

                                    </div>
                                </div>
                            ))}
                        </Slider>
                        <div class="text-center">
                        <Link class="btn btn-warning font-weight-light mt-4" to="/blogs">
                        {t('viewall')}
                                        </Link>
                        </div>
                        
                    {/* <div className="row">
                        {props.homeblogs?.map((data, index) => (
                            <>
                                {index === 0 && <div className="col-lg-3 col-12 offset-lg-1 div-1">
                                    <div className='blog-1 hoverblog' style={{ backgroundImage: `url("` + process.env.REACT_APP_IMG_URL + data.image + `")` }}>
                                        
                                        <div className='inner'>
                                            <small className='font-weight-bold text-white' style={{ fontSize: 12 }}>{data.name[i18n.language]}</small>
                                            <div className='font-weight-light text-white' style={{ fontSize: 10 }}>{data.about[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60)}...</div>
                                            <Link className='text-warn font-weight-light small' to={{pathname: `/blog-details/${data._id}`, state: {service: data}}}>
                                            {t('continuereading')} <img src={arrow} style={{ height: 10 }} />
                                            </Link>
                                        </div>
                                    </div>
                                </div>}
                                {index === 1 && <div className="col-lg-3 col-12 div-2">
                                    <div className='blog-2 hoverblog' style={{ backgroundImage: `url("` + process.env.REACT_APP_IMG_URL + data.image + `")` }}>
                                        <div className='inner'>
                                            <small className='font-weight-bold text-white' style={{ fontSize: 12 }}>{data.name[i18n.language]}</small>
                                            <div className='font-weight-light text-white' style={{ fontSize: 10 }}>{data.about[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60)}...</div>
                                            <Link className='text-warn font-weight-light small' to={{pathname: `/blog-details/${data._id}`, state: {service: data}}}>
                                            {t('continuereading')} <img src={arrow} style={{ height: 10 }} />
                                            </Link>
                                        </div>
                                    </div>
                                </div>}
                                {index === 2 && <div className="col-lg-3 col-12 py-3 py-lg-0">
                                    <div className='blog-3 hoverblog' style={{ backgroundImage: `url("` + process.env.REACT_APP_IMG_URL + data.image + `")` }}>
                                        <div className='inner'>
                                            <small className='font-weight-bold text-white' style={{ fontSize: 12 }}>{data.name[i18n.language]}</small>
                                            <div className='font-weight-light text-white' style={{ fontSize: 10 }}>{data.about[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60)}...</div>
                                            <Link className='text-warn font-weight-light small' to={{pathname: `/blog-details/${data._id}`, state: {service: data}}}>
                                            {t('continuereading')} <img src={arrow} style={{ height: 10 }} />
                                            </Link>
                                        </div>
                                    </div>
                                </div>}
                                {index === 3 && <div className="col-lg-3 div-4 col-12 offset-lg-3">
                                    <div className='blog-4 hoverblog' style={{ backgroundImage: `url("` + process.env.REACT_APP_IMG_URL + data.image + `")` }}>
                                    <div className='inner'>
                                            <small className='font-weight-bold text-white' style={{ fontSize: 12 }}>{data.name[i18n.language]}</small>
                                            <div className='font-weight-light text-white' style={{ fontSize: 10 }}>{data.about[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60)}...</div>
                                            <Link className='text-warn font-weight-light small' to={{pathname: `/blog-details/${data._id}`, state: {service: data}}}>
                                            {t('continuereading')} <img src={arrow} style={{ height: 10 }} />
                                            </Link>
                                        </div>
                                    </div>
                                </div>}
                                {index === 3 && <div className="col-lg-2 col-12 d-flex align-items-end py-5 py-lg-0">
                                    <img src={viewbtn} />
                                    <div className='btndiv'>
                                        <Link to="/blogs">
                                            <p className='text-warn'>View More</p>
                                        </Link>

                                    </div>
                                </div>}
                                {index === 4 && <div className="col-lg-4 col-12 div-5 d-none d-lg-block">
                                    <div className='blog-5 hoverblog' style={{ backgroundImage: `url("` + process.env.REACT_APP_IMG_URL + data.image + `")` }}>
                                    <div className='inner'>
                                            <small className='font-weight-bold text-white' style={{ fontSize: 12 }}>{data.name[i18n.language]}</small>
                                            <div className='font-weight-light text-white' style={{ fontSize: 10 }}>{data.about[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60)}...</div>
                                            <Link className='text-warn font-weight-light small' to={{pathname: `/blog-details/${data._id}`, state: {service: data}}}>
                                            {t('continuereading')} <img src={arrow} style={{ height: 10 }} />
                                            </Link>
                                        </div>
                                    </div>
                                </div>}
                            </>
                        ))}
                    </div> */}
                </div>
            </section>

        </>
    )
}

export default GiftBanner